module.exports = "/_next/static/images/logo-926d11bb3f612ca4bb650f59f2a50ca6.jpg";